import { Emergency, SupportAgentOutlined } from "@mui/icons-material";
import { Box, Button, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { NavLink } from "react-router-dom";

import { visitorManagementPrimaryNav } from "./visitorManagementPrimaryNav";

const tTechSupport = "Tech Support";
const tEmergency = "Emergency";

export interface VisitorManagementSideNavProps {
  onEmergency: () => void;
  onTechSupport: () => void;
}

export function VisitorManagementSideNav({ onEmergency, onTechSupport }: VisitorManagementSideNavProps) {
  return (
    <Box
      component="nav"
      sx={{
        alignSelf: "stretch",
        borderColor: "divider",
        borderRight: 1,
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
        maxWidth: 280,
        minHeight: 0,
        minWidth: 240,
        overflow: "hidden",
        py: 1,
        width: "100%",
      }}
    >
      <List sx={{ flex: "1 1 auto", minHeight: 0, overflow: "auto" }}>
        {visitorManagementPrimaryNav.map(({ Icon, ...item }) => (
          <ListItem key={item.to} disablePadding sx={{ display: "block", px: 1 }}>
            <ListItemButton component={NavLink} end={item.end} sx={{ borderRadius: 1, py: 1.25 }} to={item.to}>
              <ListItemIcon sx={{ color: "primary.main", minWidth: 44 }}>
                <Icon fontSize="medium" />
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: "1.125rem",
                  fontWeight: 500,
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Divider sx={{ my: 1 }} />

      <Box sx={{ display: "flex", flexDirection: "column", flexShrink: 0, gap: 1, px: 1.5, py: 1 }}>
        <Button
          color="error"
          fullWidth
          size="large"
          startIcon={<Emergency />}
          sx={{ fontSize: "1.0625rem", py: 1.25 }}
          variant="contained"
          onClick={onEmergency}
        >
          {tEmergency}
        </Button>
        <Button
          color="info"
          fullWidth
          size="large"
          startIcon={<SupportAgentOutlined />}
          sx={{ fontSize: "1.0625rem", py: 1.25 }}
          variant="outlined"
          onClick={onTechSupport}
        >
          {tTechSupport}
        </Button>
      </Box>
    </Box>
  );
}
